const translations = {
  fr: {
    demography: {
      demographyPageTitle: 'Démographie',
      higherAgeRange: 'Tranche Dominante',
      notEnoughData: 'Données insuffisantes',
      tryWithBiggerPeriod: 'Veuillez réessayer avec une période plus longue',
      usageExceeded: 'Utilisation journalière de la démographie dépassée',
      usageNote: 'Veuillez prendre note que l\'utilisation journalière de la démographie est limitée à {{max}}',
      cannotRenderImage: 'Impossible d\'afficher l\'image',
      gender: 'Genre',
      somethingWentWrong: 'Oups une erreur est survenue.',
      usageCounterNote: 'Nombre d\'utilisations faites : {{usage}} / {{max}}',
      forDaysDuring: 'Pour {{days}} {{timeRange}}',
      demographicSurvey: 'Sondage démograpique',
      noData: 'Pas assez de données pour générer le sondage qualitatif',
    },
  },
  en: {
    demography: {
      demographyPageTitle: 'Demography',
      higherAgeRange: 'Higher age range',
      notEnoughData: 'Insufficient data',
      tryWithBiggerPeriod: 'Please try again with a longer period',
      usageExceeded: 'Exceeded demography daily usage',
      usageNote: 'Please take note that the daily usage of demographics is limited to {{max}}',
      cannotRenderImage: 'Cannot display image',
      gender: 'Gender',
      somethingWentWrong: 'Oops something went wrong..',
      usageCounterNote: 'Daily usages limited to : {{usage}} / {{max}}',
      forDaysDuring: 'For {{days}} {{timeRange}}',
      demographicSurvey: 'Demographic Survey',
      noData: 'Not enough data available to produce the qualitative survey',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/demography/i18n/demography.js